import { createFileRoute } from "@tanstack/react-router";

import ClaimFriendshipPage from "~/pages/friends/ClaimFriendshipPage.tsx";

export const Route = createFileRoute("/_auth/friends/claim")({
    validateSearch: (search: Record<string, unknown>): { token?: string } => {
        return {
            token: typeof search.token === "string" ? search.token : undefined,
        };
    },
    component: ClaimFriendshipPage,
});
